import React from "react";
import MainLayout from "./MainLayout";

const PrivacyPolicy = () => {
  return (
    <MainLayout>
      <div className="sv-container">
        <div className="other-card">
          <h2 className="other-header">
            Privacy Policy (DPDP Act, 2023 & IT Act, 2000 compliant)
          </h2>

          <div className="svp-card-content scrollable">
            <h3>1. Introduction</h3>
            <p>
              Raychem RPG Pvt. Ltd. ("Raychem RPG", "we", "our", "us") operates
              the Training Management System ("TMS"). For the purposes of the
              Digital Personal Data Protection Act, 2023 ("DPDP Act"), Raychem
              RPG is the Data Fiduciary that determines the purposes and means
              of processing personal data within the TMS. By using the TMS, you
              acknowledge that your personal data will be processed for clear,
              lawful, and limited purposes connected to training administration.
              This Privacy Policy explains what we collect, why, how long we
              keep it, who we share it with, and the rights available to you.
            </p>

            <h3>2. Scope</h3>
            <p>
              This Policy applies to digital personal data processed in
              connection with the TMS, including personal data collected online
              or collected offline and subsequently digitised. It also applies
              where the TMS is accessed outside India for the purpose of
              services offered in India.
            </p>

            <h3>3. Categories of Personal Data We Process</h3>
            <ul>
              <li>
                Identity and Employment: name, employee ID, designation,
                department, manager mapping.
              </li>
              <li>
                Contact: official email address and business phone number.
              </li>
              <li>
                Training Data: enrolments, attendance, assessments,
                certifications, feedback, learning paths, badges.
              </li>
              <li>
                System & Security: login timestamps, activity logs,
                device/browser details, IP address (for fraud prevention, audit,
                and troubleshooting).
              </li>
            </ul>
            <p>
              We do not intentionally collect Sensitive Personal Data as defined
              under the Information Technology Act Sensitive Personal Data and
              Information Rules, 2011 (“IT Act SPDI Rules”) (e.g., passwords,
              financial data, health or biometric data) through the TMS unless
              explicitly notified and consented for a specific lawful purpose.
            </p>

            <h3>4. Lawful Basis & Purposes of Processing</h3>
            <p>
              We process personal data on the basis of your consent and/or for
              legitimate uses permitted by the DPDP Act. Primary purposes
              include:
            </p>
            <ol class="roman-parenthesis">
              <li>managing training programs and curricula;</li>
              <li>tracking progress, assessments and certifications;</li>
              <li>
                generating analytics for training effectiveness and compliance;
              </li>
              <li>information security, auditing and incident response; and</li>
              <li>complying with legal or regulatory requirements.</li>
            </ol>
            <p>
              Personal data will not be used for any incompatible purpose
              without fresh consent where required.
            </p>

            <h3>5. Notice and Consent</h3>
            <p>
              Before or at the time of collection based on consent, we provide a
              clear notice describing the data collected, purposes, the rights
              available to you, and how to contact the Grievance Officer.
              Consent is free, specific, informed, and unambiguous and may be
              withdrawn at any time via the process described in Section 9 of
              this Policy.
            </p>

            <h3>6. Data Sharing and Processing on Our Behalf</h3>
            <p>
              We may share personal data with authorised Data Processors solely
              to operate, secure, or support the TMS under written contracts
              that require confidentiality, security, breach reporting and
              deletion/return of data upon termination. Personal data may be
              disclosed to lawful authorities where required by applicable law.
            </p>

            <h3>7. Cross‑Border Transfers</h3>
            <p>
              Where cross‑border transfer is necessary, it will be undertaken in
              accordance with the DPDP framework (including any notified country
              restrictions) and with appropriate contractual safeguards. If data
              is stored solely in India, we will state that in the TMS notice.
            </p>

            <h3>8. Security Measures</h3>
            <p>
              We implement reasonable technical and organisational safeguards
              aligned with recognised standards (such as ISO/IEC 27001) to
              protect personal data against unauthorised access, alteration,
              disclosure or loss. Access is role‑based and logged. Employees and
              contractors are subject to confidentiality obligations.
            </p>

            <h3>9. Data Retention and Deletion</h3>
            <p>
              We retain personal data only for as long as necessary to fulfil
              the purposes described above or to comply with legal, regulatory,
              audit, or enforceable contractual obligations. Where retention is
              no longer required, data is securely deleted or irreversibly
              anonymised. Upon consent withdrawal, processing ceases except
              where retention is required under law.
            </p>

            <h3>10. Your Rights</h3>
            <p>Subject to applicable law, you have the right to:</p>
            <ol class="roman-parenthesis">
              <li>access information about your personal data;</li>
              <li>request correction and erasure;</li>
              <li>seek grievance redressal; and</li>
              <li>information security, auditing and incident response; and</li>
              <li>
                nominate an individual to exercise your rights in the event of
                incapacity or death.
              </li>
            </ol>
            <p>
              You may exercise these rights using the channels in Section 12 of
              this Policy.
            </p>

            <h3>11. Personal Data Breach</h3>
            <p>
              In the event of a personal data breach, we will act without undue
              delay in accordance with the DPDP framework, including required
              intimations to the Data Protection Board of India and affected
              individuals, and will take reasonable remedial steps.
            </p>

            <h3>12. Contact & Grievance Redressal</h3>
            <p>
              Grievance Officer: [Name], Raychem RPG Pvt. Ltd., [Address].
              Email: [email@raychemrpg.com]. Phone: [+91-XXXXXXXXXX].
            </p>
            <p>
              You may raise a request/complaint through the TMS helpdesk or by
              emailing the Grievance Officer. We will acknowledge and address
              your request within statutory timelines.
            </p>

            <h3>13. Changes to this Policy</h3>
            <p>
              We may update this Policy from time to time. Material changes will
              be communicated within the TMS, and where required, we will seek
              fresh consent.
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;
